import { iconSportCssClass } from "../../data/utils";
import { getLabel } from "../../InitData";
import { useLiveData } from "../LiveDataProvider";
import ContentWrapper from "../../common/ContentWrapper";
import InfoMessage from "../../common/InfoMessage";
import SportHeader from "../../common/SportHeader";
import Tournament from "../tournament/Tournament";
import SportFetcher from "../sport/SportFetcher";

export default function Home() {
    const liveData = useLiveData();

    const sport = liveData.sport;
    if (sport == null || sport.length === 0) {
        return (
            <ContentWrapper columns="1">
                <InfoMessage text={getLabel('general.no_events')} />
            </ContentWrapper>
        );
    }

    return (
        <ContentWrapper columns="1">
            {liveData.sport.map(s =>
                <SportFetcher key={s.id} sportId={s.id} renderItem={(data) => {
                    const sport = data.sportById[s.id];
                    if (sport == null) {
                        return null;
                    }

                    const sportIcon = iconSportCssClass(sport.id, sport.iconClass);

                    return (
                        <>  
                            <SportHeader icon={sportIcon} desc={sport.descrizione} />
                            {sport.categories.map(c => {
                                if (c.id === 0) {
                                    return null;
                                }
                
                                return c.tournaments.map(tournament =>
                                    <Tournament key={tournament.uniqueId} data={tournament} />
                                );
                            })}
                        </>
                    );
                }} />
            )}
        </ContentWrapper>
    );
}
